import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Column, List } from '@pella/sash-framework';
import { CTA } from '../../../';
import SimpleSlider from '../../../common/simple-slider';
import IconBox from '../../../common/icon-box';

import styles from './index.module.scss';

const SliderAndContent = ({ data, isActive, ...other }) => (
	<div
		className={`${styles.sliderContent} ${isActive ? styles.sliderContent_active : ''}`}
		{...other}
	>
		<Container>
			<Row>
				{isActive && data.images?.[0] && (
					<Column
						xs={12}
						md={6}
					>
						<SimpleSlider slides={data.images} />
					</Column>
				)}

				<Column
					xs={12}
					md={6}
				>
					<div className={styles.sliderContent_Content}>
						{data.heading && <h2 className={styles.sliderContent_ContentHeading}>{data.heading}</h2>}
						{data.subheading && (
							<h3
								className={styles.sliderContent_ContentSubheading}
								dangerouslySetInnerHTML={{
									__html: data.subheading,
								}}
							/>
						)}
						{data.description && (
							<div
								dangerouslySetInnerHTML={{
									__html: data.description,
								}}
								className={styles.sliderContent_ContentDescription}
							/>
						)}
						{data.why && (
							<div className={styles.sliderContent_WhyContent}>
								{data.why.heading && <p className={styles.sliderContent_WhyHeading}>{data.why.heading}</p>}
								{data.why.features?.[0] && (
									<Row className={styles.sliderContent_Features}>
										{data.why.features.map((feat, index) => (
											<Column
												key={index}
												xs={12}
												sm={4}
												md={12}
												lg={4}
											>
												<IconBox data={feat} />
											</Column>
										))}
									</Row>
								)}
								{data.why.available_on && <p className={styles.sliderContent_WhyHeading}>{data.why.available_on}</p>}
								{data.why.ctas?.[0] && (
									<List
										bullets='none'
										className={styles.sliderContent_WhyCtaList}
									>
										{data.why.ctas.map((link, index) => (
											<li key={index}>
												<CTA data={link} />
											</li>
										))}
									</List>
								)}
							</div>
						)}
					</div>
				</Column>
			</Row>
		</Container>
	</div>
);

SliderAndContent.propTypes = {
	data: PropTypes.object,
	isActive: PropTypes.bool,
};

export default SliderAndContent;
